'use strict'
/**
 * 解析获取.txt文本
 * zlh
 * @plugin chardet: chardet.detect 用于解析文本是什么编码格式
 */
import chardet from 'chardet'
import bus from '@/utils/bus'
export const GetText = {
  data() {
    return {
      getTextStr: '',
      textStatus: false,
    }
  },
  methods: {
    /**
     * 获取文本内容
     */
    getTxtContent(url) {
      let getTextStr
      let fileReader
      // 处理代理字段
      let baseUrl = window.gtaAiConfig.photoDomain; // 文件地址（代理）
      url =  baseUrl + '/aishixun' + url.split('/aishixun')[1];
      // let baseUrl = window.gtaAiConfig.fileBaseUrl;

      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
      })
        .then(async (res) => {
          this.textStatus = false

          let blob = res
          let encoding = ''
          try {
            encoding = await this.getTextEncoding(blob)
          } catch (e) {
            encoding = 'gbk'
          }
          fileReader = new FileReader()
          fileReader.readAsText(blob, encoding || 'gbk')

          fileReader.onloadend = (e) => {
            getTextStr = e.target.result
            getTextStr = getTextStr.replace(/\n|\r\n/g, '<br/>')
            bus.$emit('getTextStrFunc', getTextStr)
            this.getTextStr = getTextStr
            this.textStatus = true
            // console.log('getTextStr--', e.target)
          }
          fileReader.onload = (e) => {
            console.log('loading', e)
          }
        })
        .catch((error) => {
          // console.log('error-----', error)
        })
        .then((res) => {
          // console.log('res', res)
        })
    },

    /**
     * 获取编码格式
     * @param blob
     * @returns {Promise<any>}
     */
    getTextEncoding(blob) {
      return new Promise((resolve, reject) => {
        let readerArrayBuffer = new FileReader()
        readerArrayBuffer.readAsArrayBuffer(blob)
        readerArrayBuffer.onload = (e) => {
          let encoding = ''
          let arrayBuffer = e.target.result
          let uint8Array = new Uint8Array(arrayBuffer)
          let char = chardet.detect(uint8Array).toLocaleLowerCase()
          console.log('char', char)
          if (!uint8Array || uint8Array.length < 3) return (this.txt = '')

          if (char.includes('utf')) {
            encoding = 'UTF-8'
          } else {
            encoding = 'GB2312'
          }
          resolve(encoding)
          resolve(encoding)
        }
        readerArrayBuffer.onerror = reject
      })
    },
  },
}
